var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fa-wapper"},[(this.$t('edu_show_link') != 'edu_show_link')?_c('div',{staticClass:"fa-btn",on:{"click":function($event){_vm.GrandchildEvt(_vm.$t('edu_show_link'))}}},[_c('img',{staticClass:"qsicon",attrs:{"src":require("@/assets/images/question.png")}}),_c('span',[_vm._v(_vm._s(_vm.$t("新手教学")))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }